import { request } from '@/utils'

const ensureSuccess = (response, fallback) => {
  if (!response?.succeed) {
    const error = new Error(response?.errorMessage || fallback)
    error.returnCode = response?.returnCode
    throw error
  }
  return response.data
}

export const getCurrentMembership = async () => (
  ensureSuccess(await request.get('/membership/current'), '会员状态加载失败')
)

export const getMembershipPlans = async () => (
  ensureSuccess(await request.get('/membership/plans'), '套餐加载失败')
)

export const getMembershipUsage = async () => (
  ensureSuccess(await request.get('/membership/usage'), '用量加载失败')
)

export const getMembershipAccounts = async () => (
  ensureSuccess(await request.get('/membership/accounts'), '账号加载失败')
)

export const createAccountInvitation = async (email) => (
  ensureSuccess(await request.post('/membership/account-invitations', { email }), '邀请创建失败')
)

export const cancelAccountInvitation = async (id) => (
  ensureSuccess(await request.delete(`/membership/account-invitations/${id}`), '邀请撤销失败')
)

export const disableMembershipAccount = async (uid) => (
  ensureSuccess(await request.post(`/membership/accounts/${uid}/disable`), '账号停用失败')
)

export const enableMembershipAccount = async (uid) => (
  ensureSuccess(await request.post(`/membership/accounts/${uid}/enable`), '账号启用失败')
)

export const transferMembershipOwnership = async (targetUid) => (
  ensureSuccess(await request.post('/membership/ownership-transfer', null, { params: { targetUid } }), '所有权转移失败')
)

export const getMembershipOperator = async () => (
  ensureSuccess(await request.get('/membership/admin/operator'), '无平台会员运营权限')
)

export const getMembershipTenants = async (keyword = '') => (
  ensureSuccess(await request.get('/membership/admin/tenants', { params: { keyword } }), '企业会员加载失败')
)

export const getMembershipTenantEvents = async (cid) => (
  ensureSuccess(await request.get(`/membership/admin/tenants/${cid}/events`), '会员事件加载失败')
)

export const previewMembershipActivation = async (payload) => (
  ensureSuccess(await request.post('/membership/admin/activations/preview', payload, { membershipGraceRead: true }), '激活预览失败')
)

export const confirmMembershipActivation = async (payload) => (
  ensureSuccess(await request.post('/membership/admin/activations', payload, { membershipAccessExempt: true }), '会员激活失败')
)

export const suspendMembershipTenant = async (cid, reason) => (
  ensureSuccess(await request.post(`/membership/admin/tenants/${cid}/suspend`, null, { params: { reason }, membershipAccessExempt: true }), '会员冻结失败')
)

export const resumeMembershipTenant = async (cid, remark = '') => (
  ensureSuccess(await request.post(`/membership/admin/tenants/${cid}/resume`, null, { params: { remark }, membershipAccessExempt: true }), '会员解冻失败')
)
